<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >
    <!-- general tab -->
    <b-tab active>
      <!-- title -->
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">General</span>
      </template>

      <b-overlay :show="show">
        <account-setting-general
          v-if="options.general"
          :general-data="options.general"
          :user-id="userId"
        />
      </b-overlay>
    </b-tab>
    <!--/ general tab -->

    <!-- change password tab -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Change Password</span>
      </template>

      <account-setting-password
        :user-id="userId"
      />
    </b-tab>
    <!--/ change password tab -->

    <!-- info -->
    <b-tab>

      <!-- title -->
      <template #title
        v-if="options.info"
      >
        <feather-icon
          icon="InfoIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Information</span>
      </template>

      <account-setting-information
        v-if="options.info"
        :information-data="options.info"
        :user-id="userId"
      />
    </b-tab>

    <!-- social links -->
    <b-tab v-if="options.notification">

      <!-- title -->
      <template #title>
        <feather-icon
          icon="BellIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Notifications</span>
      </template>

      <account-setting-notification
        :notification-data="options.notification"
        :user-id="userId"
      />
    </b-tab>
  </b-tabs>
</template>

<script>
import { BTabs, BTab, BOverlay } from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import AccountSettingGeneral from './AccountSettingGeneral.vue'
import AccountSettingPassword from './AccountSettingPassword.vue'
import AccountSettingInformation from './AccountSettingInformation.vue'
import AccountSettingNotification from './AccountSettingNotification.vue'

export default {
  components: {
    BOverlay,
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingInformation,
    AccountSettingNotification,
  },
  data() {
    return {
      show: false,
      options: {
        general: {},
        social: {},
      },
      userId: null,
    }
  },
  created() {
    this.show = true
    useJwt.getAccountSetting()
      .then(({ data }) => {
        this.show = false
        this.userId = data.user.id
        this.options.general = data.user
      })
  },
}
</script>
